import { render, staticRenderFns } from "./ReqTrasladoTableComponent.vue?vue&type=template&id=1f04257b&scoped=true&"
import script from "./ReqTrasladoTableComponent.vue?vue&type=script&lang=js&"
export * from "./ReqTrasladoTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReqTrasladoTableComponent.vue?vue&type=style&index=0&id=1f04257b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04257b",
  null
  
)

export default component.exports